export default __webpack_public_path__ + "files/b15058574f97d97bfa8f707ffb0e6758.svg";